const ToggleOption = {
  ENABLE: 'ENABLE',
  DISABLE: 'DISABLE',
};

const ToggleSetting = {
  AUTO_ASSIGNMENT: 'isAutoAssignmentEnabled',
  AUTO_REFRESH: 'isAutoRefreshEnabled',
};

export {
  ToggleOption,
  ToggleSetting,
};
